"use client";

import React, { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Card } from "../ui/card";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Icon } from "@iconify/react";
import { toast } from "react-toastify";
import { useTranslations } from "use-intl";
type ShareDialogProps = {
  isOpen: boolean;
  onOpenChange: (isOpen: boolean) => void;
  isPublic: boolean;
  minimumVotes: number | undefined;
  pollId?: string;
};
const ShareDialog = ({
  isOpen,
  onOpenChange,
  isPublic,
  minimumVotes,
  pollId
}: ShareDialogProps) => {
  const t = useTranslations();
  const [currentUrl, setCurrentUrl] = useState("");
  useEffect(() => {
    if (!pollId) {
      setCurrentUrl(window.location.href);
    } else {
      const currentPathWithoutQuery = window.location.href.split("?")[0];
      setCurrentUrl(`${currentPathWithoutQuery}/${pollId}`);
    }
  }, [pollId]);
  const copyToClipboard = () => {
    navigator.clipboard.writeText(currentUrl).then(() => toast.success("Copied to clipboard!"), () => toast.error("Failed to copy to clipboard"));
  };
  return <Dialog open={isOpen} onOpenChange={onOpenChange} data-sentry-element="Dialog" data-sentry-component="ShareDialog" data-sentry-source-file="ShareDialog.tsx">
      <DialogContent className="max-w-lg" data-sentry-element="DialogContent" data-sentry-source-file="ShareDialog.tsx">
        <DialogHeader data-sentry-element="DialogHeader" data-sentry-source-file="ShareDialog.tsx">
          <DialogTitle data-sentry-element="DialogTitle" data-sentry-source-file="ShareDialog.tsx">{t("src_components_poll_system_ShareDialog_tsx_0")}</DialogTitle>
        </DialogHeader>
        {!isPublic && <div className="text-balance mb-2 mt-4 text-center text-sm">
            {t("poll_private_20230802124538")}
            {!!minimumVotes ? ` ${t("and_reach_20230802124539", {
          minimumVotes
        })} ` : ""}
            {t("to_make_public_20230802124540")}
          </div>}
        <div className="mt-4 flex items-center gap-2">
          <div className="flex flex-1 flex-col items-stretch justify-between gap-2">
            <Input type="text" readOnly value={currentUrl} className="w-full flex-1 justify-between" data-sentry-element="Input" data-sentry-source-file="ShareDialog.tsx" />
          </div>
          <Button onClick={copyToClipboard} className="mt-0 rounded-full bg-blue-500 font-semibold text-white hover:bg-blue-700" data-sentry-element="Button" data-sentry-source-file="ShareDialog.tsx">
            <Icon icon="ant-design:copy-outlined" className="h-5 w-5" data-sentry-element="Icon" data-sentry-source-file="ShareDialog.tsx" />
          </Button>
        </div>
      </DialogContent>
    </Dialog>;
};
export default ShareDialog;